import { mglGray } from '@/styles/designSystemColors';
import Icon from '../Icon';

// Fixo em produção: em homologação o leitor cadastraria `*.staging-canaltech.com.br`.
const PREFERRED_SOURCE_DOMAIN = 'canaltech.com.br';

export const PREFERRED_SOURCE_URL = `https://www.google.com/preferences/source?q=${PREFERRED_SOURCE_DOMAIN}`;

const GOOGLE_BORDER_GRADIENT = 'linear-gradient(90deg, #587DBD 0%, #319F43 25%, #F8BD00 50%, #E33629 100%)';

// Borda em gradiente: o fundo pinta a área interna (padding-box) e o gradiente
// pinta a faixa da borda (border-box), que fica transparente para deixá-lo aparecer.
const pillStyle = {
  border: '1px solid transparent',
  background: `linear-gradient(${mglGray.mglGray100}, ${mglGray.mglGray100}) padding-box, ${GOOGLE_BORDER_GRADIENT} border-box`,
};

type PreferredSourceButtonProps = {
  className?: string;
};

// Selo próprio, não o badge oficial do Google: o oficial PT-BR tem 338×106 px e não
// cabe na barra `h-8`. A doc do Google autoriza selo personalizado.
// Sem `share-button-click` — o GTM conta essa classe como compartilhamento.
export default function PreferredSourceButton({ className = '' }: PreferredSourceButtonProps) {
  return (
    <a
      id="PreferredSource"
      href={PREFERRED_SOURCE_URL}
      target="_blank"
      rel="noreferrer"
      title="Prefira o Canaltech no Google"
      style={pillStyle}
      className={`inline-flex h-8 min-w-0 items-center gap-[9px] rounded-full px-3 text-[11px] font-normal leading-none text-mglGray700 no-underline shadow-[0_1px_2px_rgba(0,0,0,0.08)] transition-transform duration-200 hover:scale-105 ${className}`}
    >
      <span className="truncate">Prefira o CT no Google</span>
      <Icon icon="google-g" width={12} height={12} viewBox="0 0 48 48" className="shrink-0" />
    </a>
  );
}
